import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://golden-routes-2.emergent.host").replace(/\/$/, "");
const SITE_NAME = "Líneas Doradas S.A.S.";

/**
 * SEO helper — updates document.title + meta tags per page.
 * Sets: title, meta description, og:title, og:description, og:type, og:site_name,
 *       og:url and link[rel=canonical] (both auto-derived from current path).
 * The `canonical` prop overrides the auto value if provided.
 */
export default function SEO({ title, description, canonical }) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (selector, attr, value, create) => {
      if (value == null) return;
      let el = document.querySelector(selector);
      if (!el && create) {
        el = document.createElement(create.tag);
        for (const [k, v] of Object.entries(create.attrs)) el.setAttribute(k, v);
        document.head.appendChild(el);
      }
      if (el) el.setAttribute(attr, value);
    };

    if (description) {
      setMeta('meta[name="description"]', "content", description, { tag: "meta", attrs: { name: "description" } });
      setMeta('meta[property="og:description"]', "content", description, { tag: "meta", attrs: { property: "og:description" } });
    }
    if (title) {
      setMeta('meta[property="og:title"]', "content", title, { tag: "meta", attrs: { property: "og:title" } });
    }

    // og:type + og:site_name (constant across all pages)
    setMeta('meta[property="og:type"]', "content", "website", { tag: "meta", attrs: { property: "og:type" } });
    setMeta('meta[property="og:site_name"]', "content", SITE_NAME, { tag: "meta", attrs: { property: "og:site_name" } });

    // Canonical + og:url — derived from current path unless explicitly provided
    const derivedCanonical = canonical || `${SITE_URL}${pathname}`;
    setMeta('link[rel="canonical"]', "href", derivedCanonical, { tag: "link", attrs: { rel: "canonical" } });
    setMeta('meta[property="og:url"]', "content", derivedCanonical, { tag: "meta", attrs: { property: "og:url" } });

    window.scrollTo({ top: 0, behavior: "instant" });
  }, [title, description, canonical, pathname]);

  return null;
}
